import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            type="primary"
            size="large"
            onClick={() => navigate('/dashboard')}
            className="bg-indigo-600 hover:bg-indigo-700 border-none"
          >
            Go to Dashboard
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
